// export DisposeIdea from "./disposeIdea";
// export FlowInfo from "./flowInfo";
// export FlowProcess from "./flowProcess";
// export FormCommentBox from "./formCommentBox";

// export ChooseSendNode from "./chooseSendNode";
// export ChooseSendTree from "./chooseSendTree";
// export DsfFlowAddComment from "./flowAddComment";
// export DsfFlowSelectTree from "./selectTree";

export const DsfFlowInfo = dsf.defineLazyComponent("DsfFlowInfo", () => require("./flowInfo"));

//流程意见
export const DsfDisposeIdea = dsf.defineAsyncComponent("DsfDisposeIdea", () =>
  import(/* webpackChunkName: "platform_pc_flow" */ "./disposeIdea")
);

//流程意见显示
export const DsfFormCommentBox = dsf.defineAsyncComponent("DsfFormCommentBox", () =>
  import(/* webpackChunkName: "platform_pc_flow" */ "./formCommentBox")
);

//发送过程
export const DsfFlowProcess = dsf.defineAsyncComponent("DsfFlowProcess", () =>
  import(/* webpackChunkName: "platform_pc_flow" */ "./flowProcess")
);

//流程列表
export const DsfFlowInfoList = dsf.defineAsyncComponent('DsfFlowInfoList', () =>
  import(/* webpackChunkName: "platform_pc_flow" */ "./flowInfoList.vue")
);

export const DsfFlowAddComment = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_flow" */ "./flowAddComment")
);
export const DsfFlowSelectTree = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_flow" */ "./selectTree")
);
export const ChooseSendNode = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_flow" */ "./chooseSendNode")
);
export const ChooseSendTree = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_flow" */ "./chooseSendTree")
);

export const DsfFlowFileList = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_flow" */ "./flowFileList")
);

